import css from './IconPlay.css';

const IconPlay = () => {
  return <i className={css.IconPlay} />;
};

export default IconPlay;
